import uaParser, { type IResult } from "ua-parser-js";

export const isTouchDevice = () => {
  return navigator && navigator.maxTouchPoints > 0;
};

export enum Platform {
  iPad = "iPad",
  Mac = "Mac",
  Windows = "Windows",
  iPhone = "iPhone",
  Android = "Android",
  Linux = "Linux",
  Other = "Other",
}

export class PlatformAPI {
  private static instance: PlatformAPI = new PlatformAPI();
  private readonly userAgentData: IResult = new uaParser().getResult();
  private readonly platform: Platform;

  private constructor() {
    this.platform = this.calculatePlatform();
  }

  static getInstance(): PlatformAPI {
    return this.instance;
  }

  private calculatePlatform() {
    switch (this.getOSName()) {
      case "iOS": {
        const deviceType = this.userAgentData?.device?.type;
        if (deviceType == "tablet") {
          return Platform.iPad;
        }
        return Platform.iPhone;
      }
      case "Mac OS": {
        if (isTouchDevice()) {
          return Platform.iPad;
        }
        return Platform.Mac;
      }
      case "Windows": {
        return Platform.Windows;
      }
      case "Android": {
        return Platform.Android;
      }
      case "Linux": {
        return Platform.Linux;
      }
      default:
        return Platform.Other;
    }
  }

  //Can be used for live decision making in the code (eg.: show ipad download button on ipad)
  public getPlatform() {
    return this.platform;
  }

  public isShaprSupportedPlatform() {
    return (
      this.platform === Platform.Mac ||
      this.platform === Platform.Windows ||
      this.platform === Platform.iPad
    );
  }

  //Used for analytics
  public getOSName() {
    return this.userAgentData?.os?.name;
  }
  //Used for analytics
  public getOSVersion() {
    return this.userAgentData?.os?.version;
  }
  //Used for analytics
  public getBrowserName() {
    return this.userAgentData?.browser?.name;
  }
  //Used for analytics
  public getBrowserVersion() {
    return this.userAgentData?.browser?.version;
  }
}
